import React, { Component, Fragment } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import '../style.css';
import { languages } from 'config/languages';

class LanguageSelect extends Component {
  handleClick = (name) => {
    return () => {
      this.props.onSelect(name);
    };
  }

  render() {
    return (
      <Fragment>
        <div className="mx-auto onboard-step onboard-step--2 onboard-step--language">
          <p className="step__number" data-qa-id="step1-title">Step 1/3</p>
          <h4 className="mb-2">What language are you currently learning?</h4>
          <p className="step__description">You can change this at anytime.</p>
          <div className="languages mx-4 mx-sm-0 pb-5">
            {languages.map((language, index) => (
              <div key={index} className="languages__item d-inline-block p-0">
                <div
                  className={classnames('languages__item-content mx-auto py-4 btn-cursor', {
                    selected: language.name === this.props.language
                  })}
                  onClick={this.handleClick(language.name)}
                  data-qa-id="onboard-language-button"
                >
                  <img
                    src={`/assets/country/${language.flag}`}
                    alt={language.name}
                    className="mb-3 languages__item-flag"
                  />
                  <h5>{language.name}</h5>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* <Footer onBack={onBack} onNext={onNext} /> */}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.profile
  };
}

export default connect(mapStateToProps)(LanguageSelect);



// WEBPACK FOOTER //
// ./src/pages/student/OnBoard/LanguageSelect/index.js